import React from 'react';

export default function FilterSeatsByPrice(props) {
    return (
        <button type="button" 
                className='btn--filter booking-pathway__filters--button' 
                onClick={() => props.setSelectedBands(props.selectedBands == props.price.bands ? null : props.price.bands)}
                aria-selected={props.selectedBands == props.price.bands}>
            £{parseFloat(props.price.amount).toFixed(2)}
        </button>
    );
}